/**
 * The sheet element's scroll-smoothness debug flags, read through `DomFlags`
 * (a `?flag:<name>=` URL parameter, else localStorage `debug-flag:<name>`,
 * read once per page). Moved out of sheet-element.ts; `SheetElement` reads
 * them here.
 */
import { DomFlags } from "@tento-ui/dom-flags";
import { ScrollHorizontal } from "@tento-ui/components/scroll/scroll-horizontal";
import { FRAME_BUDGET } from "@tento-ui/frame-budget";
import { scheduleModelDrain } from "./schedule-model-drain.ts";
import type { RecomputeScheduler } from "@tento-lona/sheets";

/** The scroll-smoothness flags (see each). */
export namespace SheetElementFlags {
  /**
   * `scroll-frame-deadline` (on by default), read through its one reader
   * `ScrollHorizontal.frameDeadlineMs`: per-row fixed-children applies run
   * under the frame budget (`FixedChildrenQueue`) and the row viewport reads
   * its scroll position once per frame.
   */
  export function frameDeadline(): boolean {
    return ScrollHorizontal.frameDeadlineMs() != null;
  }
  /**
   * The recompute scheduler the DOM hands a client (`browserHost` sets it as
   * `AppWiring.Host.recomputeScheduler`): with `scroll-frame-deadline` on,
   * deferred recomputes drain once per animation frame against
   * `FRAME_BUDGET.remainingMs()`; off, `null`, and the model keeps its
   * immediate drain.
   */
  export function recomputeScheduler(): RecomputeScheduler | null {
    if (!frameDeadline()) return null;
    return {
      schedule: scheduleModelDrain,
      remainingMs: () => FRAME_BUDGET.remainingMs(),
    };
  }
}
